import { useQueryClient } from "@tanstack/react-query";
import { useActiveCompany } from "../../stores/active-company";

// Switch the admin company context: persists the id (store + localStorage) and
// refreshes company-scoped caches.
export function useSetActiveCompany() {
  const queryClient = useQueryClient();
  const set = useActiveCompany((s) => s.setActiveCompanyId);
  return (id: string) => {
    set(id || null);
    void queryClient.invalidateQueries({ queryKey: ["admin", "company-users"] });
    // EEX query keys are not company-scoped; drop them so a global admin never
    // sees the previous company's cached trades/positions/margin for staleTime.
    queryClient.removeQueries({
      predicate: (q) => typeof q.queryKey[0] === "string" && q.queryKey[0].startsWith("eex-"),
    });
  };
}
